// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  font-size: 1.3rem;
  margin-bottom: 10px;
}

.no-user-yet {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 15px;
}

.bloc-user {
  margin-top: 10px;
}

@media screen and (max-width: 748px) {
  label {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/shared/modals/modal-ask-workflow/modal-ask-workflow.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI;IACI,eAAA;EACN;AACF","sourcesContent":["label {\r\n    font-size: 1.3rem;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.no-user-yet {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.bloc-user {\r\n    margin-top: 10px;\r\n}\r\n\r\n@media screen and (max-width: 748px) {\r\n    label {\r\n        font-size: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
